

export default function DevNotesPost() {
    return (
        <div>
            In an effort to add some depth to my portfolio here, I've gone and added a "Dev Notes" section to every post on the blog. It goes into the inspiration behind the post, any implementation difficulties I hit, and just any other interesting thoughts or anecdotes related to the project.
        </div>
    )
}

export function DevNotesDevNotes() {
    return (
        <div>
            Hi! :^)
        </div>
    )
}